/**
 * Custom cart functionality to prevent page refresh and show notifications
 */

// Collapses same-prefix compatibility entries: ["KaVo SUPERtorque 660","…660L"]
// -> "KaVo SUPERtorque 660/660L". Liquid mirror: snippets/fits-grouped.liquid.
window.groupFits = function (v) {
  if (!v) return '';
  if (typeof v === 'string' && v.trim().startsWith('[')) {
    try { v = JSON.parse(v); } catch (e) {}
  }
  if (!Array.isArray(v)) return v;
  const groups = new Map();
  for (const raw of v) {
    const item = String(raw).trim();
    if (!item) continue;
    const parts = item.split(/\s+/);
    let prefix, variant;
    if (parts.length < 2) {
      prefix = item;
      variant = '';
    } else {
      variant = parts.pop();
      prefix = parts.join(' ');
    }
    if (!groups.has(prefix)) groups.set(prefix, []);
    const arr = groups.get(prefix);
    if (variant && !arr.includes(variant)) arr.push(variant);
  }
  return [...groups].map(([p, vs]) => (vs.length ? p + ' ' + vs.join('/') : p)).join(' · ');
};

document.addEventListener('DOMContentLoaded', function () {
  function formatMoney(cents) {
    const amount = (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
    return `${amount} €`;
  }

  function getAddedItems(responseData) {
    if (responseData && Array.isArray(responseData.items)) {
      return responseData.items;
    }

    if (responseData && responseData.id) {
      return [responseData];
    }

    return [];
  }

  function getItemImage(item) {
    return item && (item.image || item.featured_image || item.product_image || '');
  }

  function updateCartCountFromCart(cart) {
    const count = cart ? cart.item_count : 0;
    const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count');

    cartCountElements.forEach(element => {
      element.textContent = count;
    });

    const cartCountContainers = document.querySelectorAll('a[href*="/cart"] span.absolute:not([data-cart-count-container])');
    cartCountContainers.forEach(container => {
      if (count > 0) {
        container.classList.add('text-primary-600', 'ring-transparent', 'bg-primary-100');
        container.classList.remove('text-gray-700', 'ring-gray-200');
      } else {
        container.classList.remove('text-primary-600', 'ring-transparent', 'bg-primary-100');
        container.classList.add('text-gray-700', 'ring-gray-200');
      }
    });
  }

  function showCartConfirmation(cart, responseData, fallbackItem) {
    const addedItems = getAddedItems(responseData);
    const firstItem = addedItems[0] || fallbackItem || {};
    const addedCount = addedItems.reduce((total, item) => total + (parseInt(item.quantity, 10) || 1), 0) || 1;
    const extraCount = Math.max(addedItems.length - 1, 0);
    const title = firstItem.product_title || firstItem.title || fallbackItem?.title || 'Artikel';
    const subtitle = extraCount > 0
      ? `plus ${extraCount} passender Artikel`
      : (firstItem.variant_title && firstItem.variant_title !== 'Default Title' ? firstItem.variant_title : '');

    window.dispatchEvent(new CustomEvent('cart-confirmation', {
      detail: {
        title,
        subtitle,
        image: getItemImage(firstItem) || fallbackItem?.image || '',
        addedCount,
        itemCount: cart.item_count,
        subtotal: formatMoney(cart.total_price),
        subtotalNet: formatMoney(window.theme.net(cart.total_price)) + ' exkl. MwSt.'
      }
    }));
  }

  function afterAddToCart(responseData, fallbackItem) {
    return fetch(window.routes.cartUrl + '.js')
      .then(response => response.json())
      .then(cart => {
        updateCartCountFromCart(cart);
        showCartConfirmation(cart, responseData, fallbackItem);
        return cart;
      });
  }

  window.DentrotecCart = {
    afterAdd: afterAddToCart,
    updateCount: updateCartCount
  };

  // Override the default buy button behavior with capture phase to prevent original handlers
  document.addEventListener('submit', function (event) {
    // Check if this is a product form (add to cart)
    if (event.target.matches('form[action*="/cart/add"]') ||
      event.target.closest('product-form')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      handleAddToCart(event.target);
    }
  }, true); // Use capture phase

  // Override buy-button custom element clicks with capture phase
  document.addEventListener('click', function (event) {
    // More specific selector to avoid catching unintended buttons
    // Only target buttons that are actually add-to-cart buttons
    if ((event.target.matches('buy-button button, buy-button input[type="submit"], .product-form__add-button') ||
      (event.target.matches('button[type="submit"], input[type="submit"]') &&
        (event.target.matches('[name="add"], [id*="add-to-cart"], [class*="add-to-cart"], [data-action="add-to-cart"]') ||
          event.target.textContent.toLowerCase().includes('add to cart') ||
          event.target.textContent.toLowerCase().includes('add to bag')))) &&
      event.target.closest('form[action*="/cart/add"], product-form')) {

      event.preventDefault();
      event.stopImmediatePropagation();

      const form = event.target.closest('form[action*="/cart/add"]') ||
        event.target.closest('product-form').querySelector('form');
      if (form) {
        handleAddToCart(form);
      }
    }
  }, true); // Use capture phase to intercept before theme handlers

  // REMOVED the problematic setTimeout that was cloning buy-button elements
  // This was breaking the theme's JavaScript initialization

  // Handle add to cart without page refresh
  function handleAddToCart(form) {
    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    const originalText = submitButton.textContent || submitButton.value;

    // Disable button and show loading state
    submitButton.disabled = true;
    submitButton.textContent = 'Adding...';

    // Show loading indicator
    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    // Serialize form data properly
    const formData = new FormData(form);
    const body = {};

    // Handle form serialization with proper support for arrays and multiple values
    for (const [key, value] of formData.entries()) {
      if (body[key]) {
        // If key already exists, convert to array or add to existing array
        if (Array.isArray(body[key])) {
          body[key].push(value);
        } else {
          body[key] = [body[key], value];
        }
      } else {
        body[key] = value;
      }
    }

    // Ensure quantity is a number
    if (body.quantity) {
      body.quantity = parseInt(body.quantity) || 1;
    } else {
      body.quantity = 1;
    }

    // Handle properties object if present
    const properties = {};
    for (const key in body) {
      if (key.startsWith('properties[') && key.endsWith(']')) {
        const propName = key.slice(11, -1); // Remove 'properties[' and ']'
        properties[propName] = body[key];
        delete body[key];
      }
    }
    if (Object.keys(properties).length > 0) {
      body.properties = properties;
    }

    const selectedUpsells = form.querySelectorAll('.ai-upsell-input:checked[data-id], .ai-upsell-btn.is-selected[data-id]');
    const requestBody = selectedUpsells.length > 0
      ? {
        items: [
          {
            id: body.id,
            quantity: body.quantity,
            ...(body.properties ? { properties: body.properties } : {}),
            ...(body.selling_plan ? { selling_plan: body.selling_plan } : {})
          },
          ...Array.from(selectedUpsells).map(button => ({
            id: button.getAttribute('data-id'),
            quantity: 1
          }))
        ]
      }
      : body;

    // Make AJAX request to add to cart
    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(requestBody)
    })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => Promise.reject(err));
        }
        return response.json();
      })
      .then(item => {
        return afterAddToCart(item).then(() => {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              scrollToTop: false
            }
          }));
        });
      })
      .catch(error => {
        // Error - show error notification
        const errorMessage = error.description || error.message || 'Unable to add item to cart.';
        window.dispatchEvent(new CustomEvent('show-notification', {
          detail: {
            title: 'Error',
            message: errorMessage,
            type: 'error',
            duration: 4000
          }
        }));
      })
      .finally(() => {
        // Re-enable button and restore original text
        submitButton.disabled = false;
        submitButton.textContent = originalText;
        // Hide loading indicator
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
      });
  }

  // Update cart count in header
  function updateCartCount() {
    return fetch(window.routes.cartUrl + '.js')
      .then(response => response.json())
      .then(cart => {
        updateCartCountFromCart(cart);
        return cart;
      })
      .catch(error => {

      });
  }

  // Initialize cart count on page load
  updateCartCount();

  // Live phone-availability indicator (green dot during business hours)
  (function initLiveAvailability() {
    const els = document.querySelectorAll('[data-live-availability]');
    if (!els.length) return;

    const days = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    const toMins = (t) => {
      const [h, m] = t.split(':').map(Number);
      return h * 60 + m;
    };

    let hours = {};
    try {
      hours = JSON.parse(els[0].getAttribute('data-hours') || '{}');
    } catch (e) {
      return;
    }

    const berlin = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
    const day = berlin.getDay();
    const mins = berlin.getHours() * 60 + berlin.getMinutes();
    const today = hours[day];
    const isOpen = today && mins >= toMins(today[0]) && mins < toMins(today[1]);

    function nextOpeningLabel() {
      for (let i = 0; i < 8; i++) {
        const d = (day + i) % 7;
        const h = hours[d];
        if (!h) continue;
        if (i === 0 && mins >= toMins(h[0])) continue; // today already past opening
        const time = h[0];
        if (i === 0) return 'Wieder ab ' + time + ' Uhr';
        if (i === 1) return 'Wieder morgen ' + time + ' Uhr';
        return 'Wieder ' + days[d] + ' ' + time + ' Uhr';
      }
      return '';
    }

    els.forEach((el) => {
      el.setAttribute('data-state', isOpen ? 'open' : 'closed');
      const label = el.querySelector('.live-label');
      if (label) {
        label.textContent = isOpen ? (el.getAttribute('data-label-open') || 'Jetzt erreichbar') : nextOpeningLabel();
      }
    });
  })();

  // Wrap © symbols in a span so CSS can shrink them without affecting surrounding text
  (function wrapCopyright(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(function (n) {
      if (!n.nodeValue.includes('©')) return;
      var span = document.createElement('span');
      span.innerHTML = n.nodeValue.replace(/©/g, '<span class="copy-sym">©</span>');
      n.parentNode.replaceChild(span, n);
    });
  })(document.body);
});
